import React from "react";
import styled from "styled-components";
import { Colors } from "../../../config";

const SelectFlightHeader = ({ results, activeCell, setActiveCell }) => {
  return (
    <StyledSelectFlightHeader>
      <LabelContainer>
        <TotalCountText>
          Total <span>{results} result</span>
        </TotalCountText>
      </LabelContainer>
      <FilterContainer>
        <FilterItem active={activeCell === 1} onClick={() => setActiveCell(1)}>
          Cheapest
        </FilterItem>
        <FilterItem active={activeCell === 2} onClick={() => setActiveCell(2)}>
          Best
        </FilterItem>
        <FilterItem active={activeCell === 3} onClick={() => setActiveCell(3)}>
          Quickest
        </FilterItem>
      </FilterContainer>
    </StyledSelectFlightHeader>
  );
};

const StyledSelectFlightHeader = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 1rem;
`;

const TotalCountText = styled.div`
  font-size: 1rem;
  font-weight: 600;
  color: ${Colors.white};
  > span {
    color: ${Colors.brandTwo};
  }
`;
const LabelContainer = styled.div`
  display: flex;
  gap: 1rem;
  align-items: center;
`;
const FilterContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 2rem;
`;
const FilterItem = styled.div`
  color: ${(props) => (props.active ? Colors.brandOne : Colors.white)};
  background: ${(props) => (props.active ? Colors.brandFive : "transparent")};
  font-size: 0.75rem;
  font-weight: 600;
  line-height: 2rem;
  padding: 0 1rem;
  border-radius: 1rem;
  cursor: pointer;
  :hover {
    opacity: 0.6;
  }
`;

export default SelectFlightHeader;
